module.exports = __webpack_public_path__ + "img/bangding.c9578f3d.png";